import React from "react";
import DatePickerController from "../datePickerController";
import { ASSESSMENT_FIELD_LABELS } from "../../utils/assessmentAdminFieldConfig";
/**
 * Vendor Intro Meeting row: Not Required checkbox + date picker / read-only.
 */
export default function AssessmentAdminIntroMeetingRow({
  updateActive,
  showIntroMeetingDatePicker,
  introMeetingReadKind,
  introMeetingNotRequiredChecked,
  onIntroMeetingNotRequiredChange,
  introMeetingDate,
  control,
  dateFormat,
  hide = false,
}) {
  if (hide) return null;

  let readContent = "-";
  if (introMeetingReadKind === "notRequired") {
    readContent = "Not Required";
  } else if (introMeetingReadKind === "date") {
    readContent = dateFormat(introMeetingDate);
  }

  return (
    <div className="px-0 py-4">
      <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
        <h2 className="text-sm font-medium text-gray-900">
          {ASSESSMENT_FIELD_LABELS.vendorIntroMeeting}
        </h2>
        <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-y-2">
          {updateActive && (
            <label className="inline-flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={Boolean(introMeetingNotRequiredChecked)}
                onChange={(e) => {
                  onIntroMeetingNotRequiredChange?.(e.target.checked);
                }}
              />
              Not Required
            </label>
          )}
          {(showIntroMeetingDatePicker || !updateActive) && (
            <span>
              <label htmlFor="">
                {showIntroMeetingDatePicker ? (
                  <DatePickerController
                    control={control}
                    fieldName={"introMeetingDate"}
                    value={introMeetingDate}
                    defaultValue={
                      introMeetingDate ? new Date(introMeetingDate) : null
                    }
                    disableMinDate={true}
                  />
                ) : (
                  readContent
                )}{" "}
              </label>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
